import { render, staticRenderFns } from "./PrivacyWord.vue?vue&type=template&id=0347f311&"
import script from "./PrivacyWord.vue?vue&type=script&lang=ts&"
export * from "./PrivacyWord.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyWord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports